/**
 * @module modules/day-range-sk
 * @description <h2><code>day-range-sk</code></h2>
 *
 * @evt day-range-change - Fired when the selection has stopped changing. Contains
 *      the begin and end timestamps in the details:
 *
 *      {
 *        begin: 1470084997,
 *        end: 1474184677
 *      }
 *
 * @attr {Number} begin - The beginning of the time range in seconds since the epoch.
 * @attr {Number} end - The end of the time range in seconds since the epoch.
 *
 */ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "DayRangeSk", {
    enumerable: true,
    get: function() {
        return DayRangeSk;
    }
});
const _lit = require("lit");
const _decorators = require("lit/decorators.js");
require("../calendar-input-sk");
function _ts_decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
// Converts the timestamp in seconds from the epoch into a Date.
function dateFromTimestamp(timestamp) {
    return new Date(timestamp * 1000);
}
let DayRangeSk = class DayRangeSk extends _lit.LitElement {
    createRenderRoot() {
        return this;
    }
    render() {
        return (0, _lit.html)`
      <label class="begin">
        Begin
        <calendar-input-sk
          @input=${this._beginChanged}
          .displayDate=${dateFromTimestamp(this.begin)}></calendar-input-sk>
      </label>
      <label class="end">
        End
        <calendar-input-sk
          @input=${this._endChanged}
          .displayDate=${dateFromTimestamp(this.end)}></calendar-input-sk>
      </label>
    `;
    }
    _sendEvent() {
        const detail = {
            begin: this.begin,
            end: this.end
        };
        this.dispatchEvent(new CustomEvent('day-range-change', {
            detail,
            bubbles: true
        }));
    }
    _beginChanged(e) {
        this.begin = Math.floor(e.detail.valueOf() / 1000);
        this._sendEvent();
    }
    _endChanged(e) {
        this.end = Math.floor(e.detail.valueOf() / 1000);
        this._sendEvent();
    }
    constructor(...args){
        super(...args);
        this.begin = Math.floor(Date.now() / 1000) - 24 * 60 * 60;
        this.end = Math.floor(Date.now() / 1000);
    }
};
_ts_decorate([
    (0, _decorators.property)({
        type: Number
    })
], DayRangeSk.prototype, "begin", void 0);
_ts_decorate([
    (0, _decorators.property)({
        type: Number
    })
], DayRangeSk.prototype, "end", void 0);
DayRangeSk = _ts_decorate([
    (0, _decorators.customElement)('day-range-sk')
], DayRangeSk);
